import jsonLogic from 'json-logic-js';

const applyLogic = (rules, data) => {
    if (!rules) return true;
    return Boolean(jsonLogic.apply(rules, data));
};

export default applyLogic;
